/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import Button from "../common/Button";
import Typography from "../common/new/Typography/Typography";
import styles from "./GohonzonSubHeading.styles";

function GohonzonSubHeading({ heading, submitHandler, hideAction = false }) {
  return (
    <Box style={styles.container}>
      <Box style={styles.left}>
        <Typography variant="title3" color="#8c8c8c">
          {heading}
        </Typography>
      </Box>
      {!hideAction && (
        <Box style={styles.right}>
          <Button
            size="small"
            variant="contained"
            label="CREATE BATCH"
            style={styles.createBtn}
            onClick={submitHandler}
          />
        </Box>
      )}
    </Box>
  );
}

export default GohonzonSubHeading;
